<template>
  <div class='relative flex items-start'>
    <div
      class='flex h-5 items-center'
      data-cy='check-icon'
      :data-checked='checked ? "checked" : "unchecked"'
    >
      <CheckCircleIcon
        v-if='checked'
        class='relative top-[1px] h-4 w-4 text-green-500'
      />
      <XCircleIcon
        v-else
        class='relative top-[1px] h-4 w-4 text-gray-500'
      />
    </div>
    <div class='ml-2 text-sm'>
      <label
        class='font-medium text-gray-700'
        data-cy='label'
      >
        <span
          :class='[checked && "font-bold"]'
          v-html='label'
        />
      </label>
      <p
        v-if='description'
        class='text-gray-500'
      >{{ description }}</p>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/outline'

  export default defineComponent({
    name: 'StaticListItem',
    components: {
      CheckCircleIcon,
      XCircleIcon,
    },
    props: {
      label: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        default: null,
      },
      checked: {
        type: [Boolean, Number],
        default: false,
      },
    },
  })
</script>
